<!-- 云控平台 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_innovate.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="云控平台" en="CLOUD CONTROL PLATFORM"></sub-title>
      </div>
      <div class="box">
        <img
          src="http://api.zyzxgc.cn/file/static/platform_img.png"
          class="post"
        />
        <div class="right">
          由志扬咨询自行研发搭建，打造集项目管理系统、财务管理系统、人事管理系统、数据信息管理系统、档案管理系统为一体的系统化云控数字全过程项目管理平台，实现从任务承接、项目团队组建、质量管控、进度管理、数据萃取、客户需求、价值提炼、财务管理、档案管理多维度整体协同工作的高效管理。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/platform_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .box {
    display: flex;
    margin: 70px 0 120px;

    .post {
      width: 970px;
    }
    .right {
      width: 500px;
      padding: 80px 60px;
      text-indent: 2em;
      box-sizing: border-box;
      background-color: $theme;
      color: #fff;
      line-height: 40px;
      font-size: 15px;
    }
  }
}

@media (max-width: 1500px) {
  .frame .box {
    .post {
      width: 750px;
    }
    .right {
      width: 400px;
      padding: 70px 40px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .box {
      margin: 20px 0;
      flex-direction: column-reverse;

      .post {
        width: 100%;
        height: auto;
      }
      .right {
        width: 100%;
        padding: 10px;
        line-height: 2.5;
      }
    }
  }
}
</style>
